// eslint-disable-next-line import/no-anonymous-default-export
const configUrl = {
    ImgBaseUrl:`${process.env.PUBLIC_URL}`,
    APIImagesdURL:'http://localhost:5000/'
    }
    
export default configUrl;


